// APIGEE_URLS
export const APIGEE_TOKEN_URL: any = {
    EUI_GET_CODE_REDIRECT_URL: {
        path: '/oauth2/v1/auth?client_id=TfBUpgrade&scope=TMO_ID_profile'
            + '&redirect_uri={{host}}&access_type=online&response_type=code',
        canCache: false,
        isMocked: false,
    },
    IAM_TOKEN: {
        path: '/tms/v3/usertoken',
        canCache: false,
        isMocked: false,
        apiName : 'IAM_TOKEN_CODE',
        flowType: 'IAM_FLOW',
        RedFlag: true
    },
    APIGEE_AFFILIATION_STATUS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/verify-affiliation-status.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    ENTITLEMENTS_FETCH_ACTIVITIESID_IAM: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/fetch-activities-iam.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_ORG_USER_ACTIVITIES_IOT: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/org-user-activities-iot.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_ORG_USER_ACTIVITIES_WIRELESS_IAM: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/org-user-activities-wireless-iam.json',
        canCache: false,
        isMocked: false,
    },
    // APIGEE_TRANSACTION_HISTORY_DETAILS: {
    //     path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/transaction-history-details-portin.json',
    //     canCache: false,
    //     isMocked: false,
    //     queryparam: { pageSize: '?page-size=' },
    // },
    // APIGEE_TRANSACTION_HISTORY_DETAILS: {
    //     path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/transaction-history-details-changeservice.json',
    //     canCache: false,
    //     isMocked: false,
    //     queryparam: { pageSize: '?page-size=' },
    // },
    APIGEE_TRANSACTION_HISTORY_DETAILS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/transaction-history-details-cancelsubscriber.json',
        canCache: false,
        isMocked: false,
        queryparam: { pageSize: '?page-size=' },
    },
    // APIGEE_TRANSACTION_HISTORY_DETAILS: {
    //     path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/transaction-history-details-manage-pairing.json',
    //     canCache: false,
    //     isMocked: false,
    //     queryparam: { pageSize: '?page-size=' },
    // },
    // APIGEE_TRANSACTION_HISTORY_DETAILS: {
    //     path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/transaction-history-details-port-in.json',
    //     canCache: false,
    //     isMocked: false,
    //     queryparam: { pageSize: '?page-size=' },
    // },
    APIGEE_RESET_ENGAGEMENT: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/transaction-history-reset-engagement.json',
        canCache: false,
        isMocked: false,
        queryparam: { pageSize: '?page-size=' },
    },
    APIGEE_SUBSCRIBER_LINE_DETAILS_TEA_API: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/subscriber-line-details-TEA.json',
        canCache: false,
        isMocked: false,
        flowType: 'TEA_SUBSCRIBER_LINEDETAIL_API_CALL',
    },
    LINE_DETAILS_TEA_API: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/line-details-TEA.json',
        canCache: false,
        isMocked: false,
        flowType: 'TEA_SUBSCRIBER_LINEDETAIL_API_CALL',
    },
    APIGEE_SUBSCRIBER_LINE_DETAILS_TEA_API_LINEDETAILSPAGE: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/subscriber-line-details-TEA-LineDetailsPage.json',
        canCache: false,
        isMocked: false,
        flowType: 'TEA_SUBSCRIBER_LINEDETAIL_API_CALL',
    },
    APIGEE_TRANSACTION_HISTORY: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/transaction-history.json',
        canCache: false,
        isMocked: false,
        queryparam: { orderType: '?order-type=',pageSize: '?page-size=', dateRangeLimit: '&date-range-limit=', pageNumber: '&page=',mobileNumber: '&mobile-numbers=', billingAccounts: '&billing-accounts=',submittedBy: '&submitted-by=' },
    },
    APIGEE_PAYMENT_DETAILS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/payment-detail.json',
        canCache: false,
        isMocked: false,
        queryparam: {billingAccount: '?billing-account='},
    },
    APIGEE_AUTHENTICATION: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/authentication.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_WCS_TOKEN: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/wcsToken.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    SPLUNK_LOG: {
        path: '/nodehap/log/log-in-splunk',
        canCache: false,
        isMocked: false,
    },
    APIGEE_SUSPEND_REASONS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/suspend-reasons.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_SIM_CHANGE_REASONS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/sim-change-reasons.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_SUSPEND_APPROVAL_TYPES: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/suspend-approval-types.json',
        canCache: false,
        isMocked: false,
        queryparam: { reasonCode: '?reason-code=' },
    },
    APIGEE_SUSPENSION_ELIGIBILITY: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/service-suspension-eligibility.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_SIM_CHANGE_ELIGIBILITY: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/sim-change-eligibility.json',
        canCache: false,
        isMocked: false,
        queryparam: {
            msisdn: '?msisdn=', newSim: '&new-sim=', org: '&org=',
        },
    },
    APIGEE_SERVICE_SUSPENSION: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/service-suspension.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_MILITARY_LOOKUP:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/military-lookup-affiliation-reference-info.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_FIRST_RESPONDER_LOOKUP:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/first-responder-lookup-affiliation-reference-info.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_MILITARY_LOOKUP_INFO:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/military-lookup-info.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_DOB_ENCRYPTION:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/dobEncryption.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_VERIFY_MILITARY_AFFILIATION:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/verify-military-affiliation.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_VERIFY_FIRST_RESPONDER_AFFILIATION: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/verify-first-responder-affiliation.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_VERIFY_MILITARY_DOCUMENTS:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/verify-military-documents.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_CANCEL_SUBSCRIBER_ELIGIBILITY:{
        path: './assets/tfb-acctmgmt/content-and-assets/rest-apis/cancel-subscriber-eligibility.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_SUBMIT_CANCEL_SUBSCRIBER:{
        path: './assets/tfb-acctmgmt/content-and-assets/rest-apis/submit-cancel-subscriber.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_SIM_CHANGE: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/sim-change.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_BULK_SUSPEND: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/bulkprocessor.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_BAN_ADDRESS_DETAILS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/ban-address.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_BAN_ADDRESS_UPDATE: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/ban-address.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_SIM_SWAP_BULK_PROCESSOR: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/simswapbulkprocessor.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_BULK_UPLOAD: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/bulk-upload.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_SUBSCRIBER_STATUS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/subscriber-status.json',
        canCache: false,
        isMocked: false,
        queryparam: {
            org: '?org=',
        },
    },

    APIGEE_RESTORATION_ELIGIBILITY: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/service-restoration-eligibility.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_SERVICE_RESTORE: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/restore-success.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_PORTIN_PST_DATE: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/port-in-PST-date.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_BULK_SERVICE_RESTORE: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/bulk-restore-success.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_NUMBER_CHANGE_REASON: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/change-number-reason.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_NUMBER_CHANGE_REQUEST: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/mobile-number-change.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_NUMBER_CHANGE_ELIGIBILITY: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/mobile-number-change-eligibility.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_NPA_NXX_LOOKUP: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/npa-nxx-lookup.json',
        canCache: false,
        isMocked: false,
        queryparam: {
            area_code: '?npa=',
            market_code: '?market-code=',
            zip_code: '?zip-code=',
        },
    },
    APIGEE_CHANGE_NUMBER_BULK_PROCESSOR: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/bulk-change-number.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    OKTA_ISSUER: {
        path: '/oauth2/{{okta_issuercode}}/v1/authorize?client_id={{okta_clientid}}&scope=openid'
            + '&redirect_uri={{okta_redirecturi}}&response_type=code&state=state-296bc9a0-a2a2-4a57-be1a-d0e2fd9bb602',
        canCache: false,
        isMocked: false,
    },
    OKTA_TOKEN: {
        path: './assets/content-and-assets/rest-apis/oktaTokenResponse.json',
        canCache: false,
        isMocked: false,
    },
    OKTA_USERINFO: {
        path: './assets/content-and-assets/rest-apis/oktaUserProfielResponse.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_TRANSFER_NUMBER_REQUEST: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/transfer-number-request.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_LINE_IDENTIFIER_BULK_PROCESSOR: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/line-identifier-request-bulk.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_TRANSFER_NUMBER_BULK_PROCESSOR: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/transfer-number-request-bulk.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_TRANSFER_NUMBER_ELIGIBITY_REQUEST: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/transfer-number-eligibility-request.json',
        canCache: false,
        isMocked: false,
        queryparam: '',
    },
    ENTITLEMENTS_FETCH_ACTIVITIESID_BYROLES_OKTA: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/fetchActivities-Okta.json',
        canCache: false,
        isMocked: false,
    },
    ENTITLEMENTS_FETCH_CONFIGURATIONS_AM_EXP_NEW: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/configuration.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_LINE_IDENTIFIER_CHANGE: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/line-identifier-change.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_EVALUATE_PROMOTION:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/evaluate-promotion.json',
        canCache: false,
        isMocked: false,
        queryparam: '&noCache=',
    },
    APIGEE_PLAN_CHANGE_EFFECTIVE_DATE: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/review-change-plan-services.json',
        canCache: false,
        isMocked: false,
        b2bClient: 'tfb-upgrade',
    },
    APIGEE_CHANGE_SERVICE: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/get-changeservice.json',
        canCache: false,
        isMocked: false,
        b2bClient: 'tfb-upgrade',
    },
    APIGEE_ORG_CATALOG_SERVICES: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/get-catalog-services.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_ORG_CATALOG_SERVICES'
    },
    APIGEE_DOWNLOAD_TERMS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/download-terms.json',
        canCache: false,
        isMocked: false
    },
    APIGEE_SUBSCRIBER_DETAILS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/get-subscriber-details.json',
        canCache: false,
        isMocked: false,
        b2bClient: 'tfb-upgrade',
    },
    APIGEE_SERVICE_AGREEMENT: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/service-agreement.json',
        canCache: false,
        isMocked: false,
        b2bClient: 'tfb-upgrade',
    },
    APIGEE_MANAGE_PLAN_SERVICES_API: {
        path: 'assets/tfb-acctmgmt/content-and-assets/rest-apis/managelines-plansandservice-service.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_GET_UPGRADE_ELIGIBILITY: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/line-upgrade-eligibility-profiles.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_GET_LOAN_HISTORY_NEW: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/loanHistory.json',
        canCache: false,
        isMocked: false,
        queryparam: { accountnumber: '?accountnumber=', pagenumber: '&pagenumber=', pagesize: '&pagesize=', phonenumber: '&phonenumber='}
    },
    APIGEE_CHANGESERVICES_SUBMIT: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/submit-changeservices-error.json',
        canCache: false,
        isMocked: false,
        b2bClient: 'tfb-upgrade',
    },
    APIGEE_PARTNER_SUBSCRIPTION_REDIRECTION: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/netflix-redirection.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_CHANGE_PLAN_POST: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/change-plan-post.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_CHANGE_PLAN_PUT: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/change-plan-put.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_GET_BAN_LIST_TEAAPI: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/get-banlist.json',
        canCache: false,
        isMocked: false,
        queryparam: {productType: '?product-type=',
                     msisdnFilter: '&msisdn-filter=',  userDetails: '&user-details=',
                     groupIdParams: '&params=[group-id=',
      },
    },
    APIGEE_POST_V4_SUBSCRIBERS:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/subscribers-v4.json',
        canCache: false,
        isMocked: false
    },
    CHANGE_RATE_PLAN: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/changerateplan.json',
        canCache: false,
        isMocked: false
    },
    SELECT_SERVICES: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/servicesforrateplan.json',
        canCache: false,
        isMocked: false
    },
    EMAIL_CONFIRMATION: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/email-confirmation.json',
        canCache: false,
        isMocked: false
    },
    GET_MISDIN_DETAILS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/get-lines.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_ACCOUNT_MANAGER: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/account-manager-list.json',
        canCache: false,
        isMocked: false,
        queryparam: {
        trace: {
            userId: "1-37JG8V5"
        },
        productType : "AH",
        roles : ['TEM']
    },
    },
    APIGEE_USAGE_UNBILLED_TOTAL: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/usage-unbilled-total.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        queryparam: '&noCache=',
    },
    APIGEE_BILLING_INVOICE_SUMMARY: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/billing-invoice-summary.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        queryparam: { filter: '?filter=', financialAccountNumber: '&financialAccountNumber=', mobileNumber: '&mobileNumber=' },
    },
    APIGEE_BILLING_INVOICE_SUMMARY_SEQUENCE_NUMBER: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/billing-invoice-summary-sequence.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        queryparam: { filter: '?filter=', financialAccountNumber: '&financialAccountNumber=', mobileNumber: '&mobileNumber=' },
    },
    APIGEE_BILLING_ACCOUNT_BILLS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/billing-account-bills.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        queryparam: { count: '?count=', accountnumber: '&accountnumber=' },
    },
    APIGEE_DELIQUENCY_CHECK:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/deliquency.json',
        canCache: false,
        isMocked: false,
    },
    RETRIEVE_SERVICE_API: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/retrieveOrder.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
    },
    MICRO_SERVICE_LINES_DOWNLOAD : {
      path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/line-details-multiple-ban.json',
      canCache: false,
      isMocked: false,
    },
    RETRIEVE_SERVICE_API_60: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/retrieveOrder-60.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
    },
    RETRIEVE_SERVICE_API_90: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/retrieveOrder-90.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
    },
    APIGEE_ARRPOVAL_DASHBOARD_REQUESTS_API:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/approval-dashboard-request.json',
        canCache: false,
        isMocked: false,
    } ,
    ARRPOVAL_DASHBOARD_ACTION_API:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/approval-dashboard-action.json',
        canCache: false,
        isMocked: false,
    },
    ARRPOVAL_DASHBOARD_GET_ORG_CONFIG_API: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/approval-default-comment.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_FINANCIAL_ACCOUNT_USAGE_SUMMARY: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/financial_account_summary.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        queryparam: { filterCategoryLevel: '?filterCategoryLevel=', billSequenceNumber: '&billSequenceNumber=',pagesize:'&pagesize'},
    },
	APIGEE_AUTOPAY_ELIGIBILITY_API: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/autopay-eligibility.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_AUTOPAY_INFO_API: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/autopay-info.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_AUTOPAY_DISCOUNT_ELIGIBILITY_API: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/autopay-discount-eligibility.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_BAN_FRIENDLY: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/friendly-name.json',
        canCache: false,
        isMocked: false,
    },
    APGIEE_ACCOUNT_PASSWORD_CHANGE:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/password-change.json',
        canCache: false,
        isMocked: false,
    },
    PAPERLESS_BILLING_UNENROLL: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/paperless-billing-not-enrolled.json',
        canCache: false,
        isMocked: false,
    },
    PAPERLESS_BILLING: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/paperless-billing.json',
        canCache: false,
        isMocked: false,
    },
    PAPERLESS_BILLING_EDIT: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/paperless-billing-edited.json',
        canCache: false,
        isMocked: false,
    },
    PAPERLESS_BILLING_ENROLL: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/paperless-billing-enroll.json',
        canCache: false,
        isMocked: false,
    },
    APGIEE_SUBMIT_RATEPLAN: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/submit-rateplan.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_LOCK_STATUS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/lock-status.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_DEVICE_QUERY: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/device-query.json',
        canCache: false,
        isMocked: false,
    },
    SIM_SWAP_AUTH: {
      path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/sim-swap-auth.json',
      canCache: false,
      isMocked: false,
      submitCall: true,
      apiName: 'SIM_SWAP_AUTH_VERIFY_NODE'
   },
    APIGEE_STACKABLE_PLAN: {
        path: './assets/tfb-acctmgmt/content-and-assets/rest-apis/stackable-plan.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_ARRPOVAL_DASHBOARD_VIEW_DETAILS_API:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/approval-dashboard-view-details.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_USER_ACCOUNT_QUERY_API: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/getUserAndAccountQuery.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_IOT_PRODUCT_CONFIG: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/production-config-details.json',
        canCache: false,
        isMocked: false
    },
    APIGEE_BUSINESS_CUSTOMER_SUBSCRIPTION: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/business-customer-subscription.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_SUBMIT_CART:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/orderApi.json',
        canCache: false,
        isMocked: false,
    },
    REMOVE_PACKAGE_FROM_CART:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/removeCart.json',
        canCache: false,
        isMocked: false,
    },
    //Below APIGEE_CREATE_CART and APIGEE_VALIDATE_CART constant might get differ depending on implementation of Validate API
    //START
    APIGEE_CREATE_CART:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/create-cart.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_VALIDATE_CART:{
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/validate-cart.json',
        canCache: false,
        isMocked: false
    },
    APIGEE_ORGANIZATION_SEARCH: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/organization-search.json',
        canCache: false,
        isMocked: false
    },
    APIGEE_CAT_TOOL_LINK: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/cat_tool_url.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_PAIRING_STATUS_UNPAIRED: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/pair-status-unpaired.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_PAIRING_STATUS_GSM_PAIRED: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/pair-status-gsm-line-paired.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_PAIRING_STATUS_DIGITS_PAIRED: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/pair-status-digits-line-paired.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_PAIRIN_STATUS_MULTI: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/pair-status-multi.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_PAIRING_ELIGIBILITY_VALID: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/pair-eligibility-valid.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_PAIRING_ELIGIBILITY_INVALID: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/pair-eligibility-invalid.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_MANAGE_PAIRING_SUBMIT_SUCCESS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/manage-pairing-success.json',
        canCache: false,
        isMocked: false,
    },
    APIGEE_DELINQUENCY_STATUS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/deliquency.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'DELINQUENCY_STATUS'

    },
    APIGEE_STRATEGIC_PORT_IN_PK: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/strategic-port-in-pk.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'STRATEGIC_PORT_IN_PUBLIC_KEY'
    },
    BULK_LINE_DETAILS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/bulk-line-details.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'BULK_LINE_DETAILS'
    },

    FETCH_USER_NOTIFY_CONTACT: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/user-notify-contact-list.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'FETCH_USER_NOTIFY_CONTACT'
    },

    REMOVE_USER_NOTIFY_CONTACT: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/user-notify-contact.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'REMOVE_USER_NOTIFY_CONTACT'
    },

    UPDATE_USER_NOTIFY_CONTACT: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/user-notify-contact.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'UPDATE_USER_NOTIFY_CONTACT'
    },
    FETCH_BLOCK_STATUS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/fetch-block-status.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'FETCH_BLOCK_STATUS'
    },
    FETCH_BLOCK_STATUS_BAN: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/fetch-block-status-ban-block.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'FETCH_BLOCK_STATUS'
    },
    MANAGE_BLOCK_STATUS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/manage-block-status.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'MANAGE_BLOCK_STATUS'
    },
    MANAGE_TRANSACTION_STATUS: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/manage-transaction-status.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'MANAGE_TRANSACTION_STATUS'
    },
       GENERATE_PORT_OUT_PIN: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/generate-port-out-pin.json', 
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'GENERATE_PORT_OUT_PIN'
    },
    GET_PORT_OUT_PIN: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/get-port-out-pin.json', 
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'GET_PORT_OUT_PIN'
    },
    BROADBAND_LABEL: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/subscriber-broadband-label.json',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'BROADBAND_LABEL'
    }
};

export const CONTENT_PAGES_URL: any = {
    CONTENT_ACCOUNT_MANAGEMENT: {
        path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/account-management-authoring.json',
        canCache: false,
        isMocked: false,
    },
};
